import React, { useState, useRef } from 'react';
import Text from '../../Base/Text/Text';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './FileUpload.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import { IValidationError } from '../../Form/FormControl';
import useTranslation from '../../../Hooks/useTranslation';

interface FileUploadProps {
	onChange?: any;
	onFocus?: any;
	placeholder?: string;
	required?: boolean;
	value?: string;
	className?: string;
	id?: string;
	error?: IValidationError;
	onClick?: () => void;
	isMulti?: boolean;
}

export default function FileUpload(props: FileUploadProps) {
	const {
		onChange,
		onFocus,
		placeholder,
		required = false,
		className,
		error,
		onClick,
		isMulti = false,
		value: _value,
		...restInputProps
	} = props;
	const { t } = useTranslation();

	const [files, setFiles] = useState<File[]>([]);

	const hiddenFileInput = useRef<HTMLInputElement | null>(null);

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selected = e.currentTarget.files
			? Array.from(e.currentTarget.files)
			: [];
		setFiles(selected);
		onChange?.(e);
	};

	const handleFilePick = () => {
		hiddenFileInput.current?.click();
	};

	const renderLabel = () => {
		if (!files.length) return null;
		if (files.length === 1) {
			const name = files[0].name;
			return name.length > 40 ? name.substring(0, 40) + '…' : name;
		}
		if (files.length < 5) {
			return t('component.fileUpload.selected.two', { count: files.length });
		}
		return t('component.fileUpload.selected.many', { count: files.length });
	};

	return (
		<div className={styles.wrapper}>
			<div
				className={joinClasses([
					className,
					'form-control',
					styles.fakeInput,
					error && styles.invalid,
				])}
				onClick={handleFilePick}>
				{files.length ? (
					<div className={styles.fileName}>{renderLabel()}</div>
				) : (
					<Text className={styles.placeholder} tx='base.fileIsNotPicked' />
				)}
				<Text className={styles.button} tx='base.pickFileFromComputer' />
			</div>

			<input
				{...restInputProps}
				type='file'
				multiple={isMulti}
				onChange={handleOnChange}
				placeholder={placeholder}
				onFocus={onFocus}
				className={styles.input}
				ref={hiddenFileInput}
				onClick={onClick}
			/>

			{error && (
				<div className={styles.errorMessage}>
					<Text tx={error.message} inline={true} />
				</div>
			)}
		</div>
	);
}
